<template>
	<el-row class="points-show">
		<!-- 顶部栏 -->
		<el-col :span="24">
			<el-col :span="10">销售计划</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addPlan(1)" plain>
					创建计划<i class="el-icon-plus"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<!-- 搜索栏 -->
		<el-row :gutter="20">
			<el-col :span="4">
				<div class="search-view">
					<div>显示状态：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="searchform.status">
						<el-option v-for="(item, index) in reviewStatus" :key="index" :label="item.title"
							:value="item.type" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="search-view">
					<div>主推品类：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="searchform.mainCategory">
						<el-option v-for="item in CategoryList" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="search-view">
					<div>关键字：</div>
					<el-input size="mini" v-model="searchform.name" placeholder="请输入关键字" clearable />
				</div>
			</el-col>
			<el-col :span="7">
				<div>时间筛选：</div>
				<el-date-picker size="mini" style="margin-left: 10px" format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss" v-model="searchform.datevalue" type="datetimerange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
			</el-col>
			<el-col :span="1">
				<el-button plain size="mini" type="primary" style="margin-left: 10px" @click="search">搜索</el-button>
				<el-button plain style="margin-left: 30px" size="mini" type="primary" @click="Empty">清空</el-button>
			</el-col>
		</el-row>
		<!-- table -->
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column type="index" width="30"></el-table-column>
				<el-table-column prop="name" label="计划主题" />
				<el-table-column prop="ztplName" label="主推品类" />
				<el-table-column prop="skills" label="推荐商品">
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.sysSalesPlanProducts" :key="index">{{item.productName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="计划时间">
					<template slot-scope="scope">
						<span>
							{{scope.row.startTime}} ~ {{scope.row.endTime}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="显示状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" type="success" size="mini">显示</el-tag>
						<el-tag v-if="scope.row.status == 1" type="warning" size="mini">隐藏</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="上传时间">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="230px">
					<template slot-scope="scope">
						<el-button plain size="mini" type="info" @click="addPlan(2, scope.row)">编辑</el-button>
						<el-button plain type="danger" size="mini" @click="delPlan(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<!--  创建计划弹框 -->
		<el-dialog :title="isadd == 1 ? '创建计划' : '修改计划'" :visible.sync="dialogVisible" :before-close="closeUpdate"
			width="30%">
			<!-- 新增计划 -->
			<template v-if="isadd == 1">
				<el-form :model="addform" label-position="right" label-width="120px">
					<el-form-item label="计划主题:">
						<el-input size="mini" :rows="5" placeholder="请输入内容" v-model="addform.name">
						</el-input>
					</el-form-item>
					<el-form-item label="主推品类:">

						<el-select placeholder="请选择" clearable size="mini" v-model="addform.mainCategory">
							<el-option v-for="item in CategoryList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="addform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{item.title}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="计划时间:">
						<el-date-picker size="mini" v-model="addform.startTime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
						</el-date-picker>
						<div style="text-align: center; width: 220px; line-height: normal">
							-
						</div>
						<el-date-picker size="mini" v-model="addform.endTime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="关联商品:">
						<el-button type="primary" plain size="mini" @click="addAnswerItem">添加关联商品</el-button>
					</el-form-item>
					<!-- 关联商品列表 -->
					<div class="scroll-view">
						<el-form-item v-for="(item, index) in addform.ProductList" :key="index"
							:label="'商品' + (index + 1)">
							<el-col>
								<el-input size="mini" :disabled="true" :rows="3" placeholder="请选择关联商品"
									v-model="addform.ProductList[index].productName">
								</el-input>
								<el-button type="primary" size="mini" icon="el-icon-plus" circle style="margin: 0 10px"
									@click="addProductItem(index)"></el-button>
								<el-button type="danger" size="mini" icon="el-icon-delete" circle
									style="margin: 0 10px 0 0" @click="delAnswerItem(index)"></el-button>
							</el-col>
						</el-form-item>
					</div>
				</el-form>
			</template>

			<!-- 修改计划 -->
			<template v-else>
				<el-form :model="editform" label-position="right" label-width="120px">
					<el-form-item label="计划主题:">
						<el-input size="mini" :rows="5" placeholder="请输入内容" v-model="editform.name">
						</el-input>
					</el-form-item>
					<el-form-item label="主推品类:">

						<el-select placeholder="请选择" clearable size="mini" v-model="editform.mainCategory">
							<el-option v-for="item in CategoryList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="editform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{item.title}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="计划时间:">
						<el-date-picker size="mini" v-model="editform.startTime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
						</el-date-picker>
						<div style="text-align: center; width: 220px; line-height: normal">
							-
						</div>
						<el-date-picker size="mini" v-model="editform.endTime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="关联商品:">
						<el-button type="primary" plain size="mini" @click="addAnswerItem">添加关联商品</el-button>
					</el-form-item>
					<!-- 关联商品列表 -->
					<div class="scroll-view">
						<el-form-item v-for="(item, index) in editform.ProductList" :key="index"
							:label="'商品' + (index + 1)">
							<el-col>
								<el-input size="mini" :disabled="true" :rows="3" placeholder="请选择关联商品"
									v-model="editform.ProductList[index].productName">
								</el-input>
								<el-button type="primary" size="mini" icon="el-icon-plus" circle style="margin: 0 10px"
									@click="addProductItem(index)"></el-button>
								<el-button type="danger" size="mini" icon="el-icon-delete" circle
									style="margin: 0 10px 0 0" @click="delAnswerItem(index)"></el-button>
							</el-col>
						</el-form-item>
					</div>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addScattered()">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 选择商品 -->
		<el-col :span="24">
			<el-drawer title="查询商品" :visible.sync="table" direction="rtl" size="50%" style="overflow: auto">
				<div style="margin-top: 20px; margin-bottom: 20px; overflow: auto">
					<span style="margin: 20px">商品名称</span>
					<el-input v-model="keyword" size="mini" style="width: 200px; margin-right: 20px" />
					<el-button size="small" @click="searchProduct(true)">
						搜索
					</el-button>
				</div>
				<div>
					<div style="overflow: auto">
						<el-table :data="tableDataProduct" border style="width: 99%">
							<el-table-column prop="id" label="商品id" align="center" />
							<el-table-column prop="code" label="货号" align="center" />
							<el-table-column label="缩略图" align="center">
								<template slot-scope="scope">
									<el-image :src="
                      tableDataProduct[scope.$index].pics.split(',')[0] +
                      '?x-oss-process=image/resize,w_50'
                    " fit="fill" :preview-src-list="scope.row.preview" />
								</template>
							</el-table-column>
							<el-table-column prop="name" label="商品名称" align="center" />
							<el-table-column prop="price" label="价格" align="center" />
							<el-table-column label="原料状态" align="center">
								<template slot-scope="scope">
									<span>{{
                    tableDataProduct[scope.$index].materielType === 1
                      ? "成品"
                      : "原料"
                  }}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="danger" size="mini" @click="clickProductIs(scope.row)">
										选择
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
					:page-size="pageSize2" :page-sizes="[30, 50, 100]" :total="total2" :current-page.sync="pageNum2"
					@size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
			</el-drawer>
		</el-col>
	</el-row>
</template>

<script>
	import {
		getGroupList
	} from '../../../util/index.js'
	import httpClient from "../../../util/request.js";
	var vm;
	export default {
		data() {
			return {
				name: '',
				startTime: '',
				endTime: '',
				mainCategory: '',
				status: '',
				currentOptionIndex: -1, //要给哪个弹框添加商品
				total2: 0,
				pageNum2: 1,
				pageSize2: 10,
				tableDataProduct: [],
				keyword: "",
				table: false,
				CategoryList: [],
				tableHeight: window.innerHeight - 300,
				dialogVisible: false,
				pageSize: 10,
				pageSizes: [10, 20, 30, 40, 50],
				pageNum: 1,
				tableData: [],
				total: 0,
				searchform: {
					datevalue: [],
					name: "",
					status: "",
					mainCategory: ''
				},
				addform: {
					name: '',
					ProductList: [],
					startTime: "",
					endTime: "",
					mainCategory: "",
					status: -1
				},
				editform: {
					id: '',
					name: '',
					ProductList: [],
					startTime: "",
					endTime: "",
					mainCategory: "",
					status: -1
				},
				reviewStatus: [{
						title: "显示",
						type: 0,
					},
					{
						title: "隐藏",
						type: 1,
					},
				],
				isadd: "", //判断添加还是编辑
			};
		},
		mounted() {
			vm = this;
			this.addform.startTime = this.$moment().format("YYYY-MM-DD HH:MM:SS");
			this.addform.endTime = this.$moment().format("YYYY-MM-DD HH:MM:SS");
			this.getTable();
			this.getScatteredDicAll(); //获取品类
			this.searchProduct(); //查询商品
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			//获取数据列表
			getTable() {
				let data = {
					startTime: this.startTime,
					endTime: this.endTime,
					name: this.name,
					ztpl: this.mainCategory,
					status: this.status
				}
				this.$http
					.post(
						`/api/source/syssalesplan/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`,
						data
					)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, "查询计划");
							let list = res.data.data.list;
							this.tableData = list;
							this.total = res.data.data.total;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//获取石头品类
			getScatteredDicAll() {
				getGroupList('知识点模块', '品类')
					.then(res => {
						this.CategoryList = res
					})
			},
			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},

			//搜索
			search() {
				this.name = this.searchform.name
				this.status = this.searchform.status
				this.mainCategory = this.searchform.mainCategory
				if (this.searchform.datevalue.length > 0) {
					this.startTime = this.searchform.datevalue[0]
					this.endTime = this.searchform.datevalue[1]
				}
				console.log(typeof this.startTime);
				this.pageNum = 1;
				this.getTable();
			},

			//清空
			Empty() {
				this.name = this.searchform.name = "";
				this.status = this.searchform.status = ''
				this.mainCategory = this.searchform.mainCategory = ''
				this.searchform.datevalue = []
				this.startTime = ''
				this.endTime = ''
				this.pageNum = 1;
				this.search();
			},

			//弹框取消
			closeUpdate() {
				this.editform = {
					id: '',
					name: '',
					ProductList: [],
					startTime: "",
					endTime: "",
					mainCategory: "",
					status: -1
				}
				this.addform = {
					name: '',
					ProductList: [],
					startTime: "",
					endTime: "",
					mainCategory: "",
					status: -1
				}
				this.dialogVisible = false;
			},

			//确定
			addScattered() {
				let _this = this;
				//添加
				if (this.isadd == 1) {
					if (
						!this.addform.name.trim() ||
						this.addform.status < 0 ||
						this.addform.startTime == '' ||
						this.addform.endTime == '' ||
						this.addform.mainCategory == '' ||
						this.addform.ProductList.length <= 0

					) {
						return this.$message({
							type: "error",
							message: "请填写完整计划再提交~~",
						});
					}
					let arr = [...this.addform.ProductList]
					let resultList = this._.uniqBy(arr.filter(item => item.productId !== ''), 'productId')
					var data = {
						name: this.addform.name,
						sysSalesPlanProducts: resultList,
						ztpl: this.addform.mainCategory,
						startTime: this.addform.startTime,
						endTime: this.addform.endTime,
						status: this.addform.status,
						deleteStatus: 0
					};

					this.$http
						.post(`/api/source/syssalesplan/insert`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加计划成功！！",
								});
								this.getTable();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isadd == 2) {
					let arr = [...this.editform.ProductList]
					let resultList = this._.uniqBy(arr.filter(item => item.productId !== ''), 'productId')
					var data = {
						id: this.editform.id,
						name: this.editform.name,
						sysSalesPlanProducts: resultList,
						ztpl: this.editform.mainCategory,
						startTime: this.editform.startTime,
						endTime: this.editform.endTime,
						status: this.editform.status,
					};

					this.$http
						.post(`/api/source/syssalesplan/update`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改话术成功！！",
								});
								_this.closeUpdate();
								this.getTable();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},

			//添加计划
			addPlan(type, val) {
				this.isadd = type;
				if (type == 2) {
					this.editform.name = val.name;
					this.editform.id = val.id;
					this.editform.status = val.status;
					this.editform.ProductList = val.sysSalesPlanProducts
					this.editform.startTime = val.startTime
					this.editform.endTime = val.endTime
					this.editform.mainCategory = val.ztpl
				}
				this.dialogVisible = true;
			},
			//添加关联商品列表
			addAnswerItem() {
				if (!this.editform.ProductList) {
					this.editform.ProductList = []
				}
				let item = {
					productId: "",
					productName: "",
				};
				if (this.isadd == 1) {
					let list = [...this.addform.ProductList];
					list.push(item);
					this.addform.ProductList = list;
				} else {
					let list = [...this.editform.ProductList];
					list.push(item);
					this.editform.ProductList = list;
				}

			},
			//删除关联商品列表
			delAnswerItem(index) {
				if (this.isadd == 1) {

					let list = [...this.addform.ProductList];
					list.splice(index, 1);
					this.addform.ProductList = list;
				} else {
					let list = [...this.editform.ProductList];
					list.splice(index, 1);
					this.editform.ProductList = list;
				}
			},
			addProductItem(index) {
				this.currentOptionIndex = index;
				this.table = true;
			},
			//关联商品切换页面++++++++++++++++++++++++
			// 查询商品
			searchProduct(ischange) {
				if (ischange) {
					this.pageNum2 = 1;
				}
				let url = "/api/product/product/product";
				return this.$http
					.get(url, {
						params: {
							pageNum: this.pageNum2,
							pageSize: this.pageSize2,
							keyword: this.keyword,
							// status:''
							sort: -1,
						},
					})
					.then((res) => {
						this.tableDataProduct = res.data.data.list;
						this.tableDataProduct.forEach((item, index) => {
							item.preview = [];
							item.preview = item.pics.split(",");
						});
						this.total2 = res.data.data.total;
					});
			},
			handleSizeChange2(val) {
				this.pageSize2 = val;
				this.searchProduct(false);
			},
			handleCurrentChange2(val) {
				this.pageNum2 = val;
				this.searchProduct(false);
			},
			clickProductIs(val) {
				if (this.isadd == 1) {
					let index = this.currentOptionIndex;
					let list = [...this.addform.ProductList];
					(list[index].productId = val.id), (list[index].productName = val.name);
					this.addform.ProductList = list;
				} else {
					let index = this.currentOptionIndex;
					let list = [...this.editform.ProductList];
					(list[index].productId = val.id), (list[index].productName = val.name);
					this.editform.ProductList = list;
				}

				this.table = false;
			},
			delPlan(id) {
				this.$confirm('此操作将删除该条计划, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/syssalesplan/deleteByPk/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTable()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	/deep/ .el-input {
		width: auto;
	}
</style>
